/**
 * Responsibility: turn a saved row back into a query.
 *
 * Its own file because two places need it - the saved list runs a row, and
 * the search box runs one picked from its completions - and a component
 * file that also exports a helper breaks fast refresh.
 *
 * The filters travel with the phrase. A saved search that gave back only
 * its words would quietly ask a different question from the one that was
 * saved, which is the whole thing worth keeping about it.
 */
import type { MarketQuery, SavedSearch } from '../../api/client';

export function queryOf(entry: SavedSearch): MarketQuery {
  return {
    q: entry.query,
    mode: entry.mode as MarketQuery['mode'],
    category: (entry.category ?? '') as MarketQuery['category'],
    minRaw: entry.min_raw ?? '',
    maxRaw: entry.max_raw ?? '',
    minValue: entry.min_value ?? '',
  };
}
